import React, { useEffect, useMemo, useState } from 'react';
import InfoDialog from '../../../components/shared/InfoDialog';
import { Stack } from '@mui/material';
import SelectGroup from '../../../components/casino/SelectGroup';
import CusInput from '../../../components/material-ui/CusInput';
import CusLabelSelect from '../../../components/material-ui/CusLabelSelect';
import { colorByUsersStatus, ENUM_USERS_TYPE, popupInfoByType } from '../../../enums/enums';
import useToast from '../../../hooks/useToast';
import TypographyText from '../../../components/material-ui/table/TypographyText';
import { useTranslation } from 'react-i18next';
import CusPassWitchGen from '../../../components/material-ui/CusPassWitchGen';
import { API_USERS } from '../../../api/users';
import { dispatchCusEvent } from '../../../utils';
import { ChangeSelectUser } from '../users/UserTable';

export default function AddNewUser({ open, closeModal, defaultSelectGroupId }) {
  const { t } = useTranslation();
  const { errorToast, successToast } = useToast();
  const [selectGroupId, setSelectGroupId] = useState(defaultSelectGroupId);
  const [login, setLogin] = useState('');
  const [userType, setUserType] = useState('');
  const [password, setPassword] = useState('');

  const onSaveClick = () => {
    if (!selectGroupId) {
      errorToast('Select default group');
      return;
    }

    if (!login) {
      errorToast('Please enter login');
      return;
    }

    if (!password) {
      errorToast('Please enter password');
      return;
    }

    if (password.length < 8) {
      errorToast('The minimum password length must be 8 characters');
      return;
    }

    if (!userType) {
      errorToast('User type is required');
      return;
    }

    const data = { groupId: selectGroupId, login, psword: password, type: userType };
    API_USERS.new(data)
      .then((e) => {
        const userId = e.data.userId;
        successToast('User created');
        closeModal();
        dispatchCusEvent('UserListContent.onFindClick', {
          successFn: () => {
            dispatchCusEvent(ChangeSelectUser, { userId });
          }
        });
      })
      .catch(console.error);
  };

  const optionsUserType = Object.values(popupInfoByType).map((el) => ({
    label: (
      <Stack direction={'row'} gap={1} alignItems={'center'}>
        {<el.icon size={16} color={colorByUsersStatus[el.value]} />}{' '}
        <TypographyText>{t(el.text)}</TypographyText>
      </Stack>
    ),
    value: el.value
  }));

  const optionsType = useMemo(() => {
    const optionsType = [...optionsUserType];
    const deleteIndx = optionsType.findIndex((el) => el.value == ENUM_USERS_TYPE.gamer);
    delete optionsType[deleteIndx];
    return optionsType.filter((el) => el);
  }, []);

  useEffect(() => {
    if (!open) return;
    setSelectGroupId(defaultSelectGroupId);
    setLogin('');
    setPassword('');
    setUserType('');
  }, [open, defaultSelectGroupId]);

  return (
    <InfoDialog
      open={open}
      onClose={closeModal}
      title={'Adding a user'}
      maxWidth="xs"
      onSaveClick={onSaveClick}>
      <Stack gap={2}>
        <SelectGroup
          selectGroupId={selectGroupId}
          setSelectGroupId={setSelectGroupId}
          title="Registration group"
          hideTooltip
          direction="column"
        />

        <CusInput
          autoFocus={open}
          label={'Login'}
          value={login}
          onChange={(e) => setLogin(e.target.value)}
        />
        <CusPassWitchGen password={password} setPassword={setPassword} genParam={{ length: 20 }} />

        <CusLabelSelect
          label={'User type'}
          options={optionsType}
          value={userType}
          onChange={setUserType}
        />
      </Stack>
    </InfoDialog>
  );
}
